export const companyID = () => {
  const user = localStorage.getItem("user");
  if (user) {
    const companyID = JSON.parse(user);
    const company_id = companyID.company.company_id;
    return company_id;
  }
  return null;
};

export const employeeDetails = () => {
  const user = localStorage.getItem("user");
  if (user) {
    const details = JSON.parse(user);
    return details;
  }
  return null;
};

export const DepartmentID = () => {
  const user = localStorage.getItem("user");
  if (user) {
    const parseUSer = JSON.parse(user);
    const depart_id = parseUSer?.department_id;
    return depart_id;
  }
  return null;
};

export const DesignationID = () => {
  const user = localStorage.getItem("user");
  if (user) {
    const parseUSer = JSON.parse(user);
    const desig_id = parseUSer?.designation_id;
    return desig_id;
  }
  return null;
};

export const getEmployeeLocalDetails = () => {
  const user = localStorage.getItem("user");
  if (user) {
    const parseUSer = JSON.parse(user);
    return parseUSer;
  }
  return null;
};
